<template>
    
    <div>

        <v-toolbar
        :color="eventData.color"
        dark
        >
            <v-btn icon
                @click="closeWindow"
                v-if="isShowCloseButton"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title v-html="eventData.name"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list light>
                    <v-list-item :to="{name:'seminar.detail',params : { return_address : 'seminar.calendar'}, query: {id: eventData.id}}">
                        <v-list-item-title>個別ページ</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-show="currentUserIsHost(eventData)" :to="{name:'host.create2',params : { gc_id : eventData.id, type:eventData.type, return_address : 'seminar.calendar'}}">
                        <v-list-item-title>編集</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-show="currentUserIsHost(eventData)"  @click="delete_event">
                        <v-list-item-title>削除</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-show="currentUserIsHost(eventData)" :to="{name:'host.create2',params : { gc_id : eventData.id, type:eventData.type, return_address : 'seminar.calendar', copy: true}}">
                        <v-list-item-title>コピーして新規作成</v-list-item-title>
                    </v-list-item>
                    <v-dialog
                        v-model="dialog"
                        scrollable
                        max-width="800px"
                    >
                    <template v-slot:activator="{ on, attrs }">
                    <v-list-item 
                        v-show="currentUserIsHost(eventData)" 
                        v-bind="attrs"
                        v-on="on"
                        @click="loadChipsAttend(eventData)"
                    >
                        <v-list-item-title>代理登録・キャンセル</v-list-item-title>
                    </v-list-item>
                    </template>
                    <v-card>
                        <v-card-title>代理登録・キャンセル</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text style="height: 300px;">
                            <!-- <div v-for="att in this.eventData.attendee" v-bind:key="att">
                                {{att}}
                                <span class="mr-2" v-for="(attendee, key) in eventData.attendee" v-bind:key="key">
                                    {{getUserName(attendee)}}{{(key != eventData.attendee.length - 1)?", ":""}}
                                </span>
                            </div> -->
                            <!-- <v-combobox
                                v-model="chipsAttend"
                                :items="itemsAttend"
                                chips
                                label="参加者"
                                multiple
                                prepend-icon="mdi-filter-variant"
                                solo
                            >
                                <template v-slot:selection="{ attrs, item, select, selected }">
                                <v-chip
                                    v-bind="attrs"
                                    :input-value="selected"
                                    close
                                    @click="select"
                                    @click:close="remove(item)"
                                >
                                    <strong>{{ item }}</strong>&nbsp;
                                </v-chip>
                                </template>
                            </v-combobox> -->



                            <v-autocomplete
                                v-model="chipsAttend"
                                :items="itemsAttend"
                                filled
                                chips
                                label="参加者"
                                multiple
                            >
                            <template v-slot:selection="data">
                                <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                                >
                                {{ data.item }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template>
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                            </template>
                            </v-autocomplete>


                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                        >
                            キャンセル
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="updateAttendee(eventData)"
                        >
                            更新
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                    </v-dialog>



                </v-list>
            </v-menu>
        </v-toolbar>




        <v-card-text v-if="eventData">
            <div>                
                {{eventData.name}}
                
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">

                            <v-icon
                                class="ml-2"
                                v-bind:color="'primary'"
                                v-bind="attrs"
                                v-on="on"
                                small>
                                mdi-code-tags</v-icon>

                    </template>
                    <span>{{eventData.id}}</span>
                </v-tooltip>

            </div>
            <v-divider class="py-2"></v-divider>
            <div
                v-for="(dsc, index) in splitDescription(eventData.description)"
                v-bind:key="index"
            >
                {{dsc}}<br>
            </div>
            <div>
                <a class="mr-2" v-if="eventData.link" :href="eventData.link" target="_blank">詳細へのリンク</a>
                <a class="mr-2" v-if="eventData.attendLink" :href="eventData.attendLink" target="_blank">参加リンク</a>
            </div>
            <v-divider class="py-2"></v-divider>
            <!-- <v-spacer class="pb-2"></v-spacer> -->
            
            <v-chip
                v-for="tag in eventData.tags"
                v-bind:key=tag
                class="mr-2"
                label
                color="cyan"
                @click="clickedTag(tag)"
            >
                {{tag}}
            </v-chip>


            <div>
                主催者 ： {{getUserName(eventData.host)}}
            </div>
            <div>
                <span class="mr-4">
                    開催日時：{{eventData.date}} ({{eventData.yobi}})
                </span>
                <span>
                    {{eventData.start_time.HH}}：{{eventData.start_time.mm}}～{{eventData.end_time.HH}}：{{eventData.end_time.mm}}
                </span>
            </div>
            <div>
                <span >参加者：</span>
                <span class="mr-2" v-for="(attendee, key) in eventData.attendee" v-bind:key="key">
                    {{getUserName(attendee)}}{{(key != eventData.attendee.length - 1)?", ":""}}
                </span>
                <span v-if="eventData.attendee.length == 0">なし</span>
                ( {{eventData.attendee?eventData.attendee.length:0}}／{{eventData.capacity==0?'∞':eventData.capacity}} )
                <v-chip
                    class="ml-2"
                    color="red"
                    text-color="white"
                    v-show="eventData.attendee && eventData.capacity!=0 && eventData.capacity==eventData.attendee.length"
                    >
                    満席
                </v-chip>
                <v-chip
                    class="ml-2"
                    color="primary"
                    text-color="white"
                    v-show="eventData.attendee && eventData.capacity!=0 && eventData.capacity>eventData.attendee.length"
                    >
                    空きあり
                </v-chip>
                <v-chip
                    class="ml-2"
                    color="red"
                    text-color="white"
                    v-show="eventData.attendee && eventData.capacity!=0 && eventData.capacity<eventData.attendee.length"
                    >
                    定員オーバー
                </v-chip>
                <v-chip
                    class="ml-2"
                    color="secondary"
                    text-color="white"
                    v-show="eventData.capacity==0"
                    >
                    定員なし
                </v-chip>
            </div>
            <div>
                {{eventData.acceptWatcher?'視聴参加可':'視聴参加不可'}}
            </div>
            <div>
                <span >視聴参加者：</span>
                <span class="mr-2" v-for="(watcher, key) in eventData.watcher" v-bind:key="key">
                    {{getUserName(watcher)}}{{(key != eventData.watcher.length - 1)?", ":""}}
                </span>
            </div>
            <div v-if="eventData.chatroom && eventData.chatroom.abbr != null">
                {{eventData.chatroom.room}}
            </div>
        </v-card-text>
        <v-card-actions >
            <div v-show="!currentUserIsHost(eventData)">
                <v-btn
                    color="primary lighten-2"
                    @click="reserve(eventData.id, eventData)"
                    v-show="showAttendButton(eventData)"
                    v-bind:disabled="loading"
                >
                    参加
                </v-btn>
                <v-btn
                    color="primary lighten-2"
                    @click="reserveAsWatcher(eventData.id, eventData)"
                    v-show="showWatcherAttendButton(eventData)"
                    v-bind:disabled="loading"
                    class="ml-2"
                >
                    視聴参加
                </v-btn>
                <v-btn
                    color="red lighten-2"
                    @click="cancel(eventData)"
                    v-show="showCancelButton(eventData)"
                    v-bind:disabled="loading"
                    class="ml-2"
                >
                    キャンセル
                </v-btn>
                <v-btn
                    color="red lighten-2"
                    @click="cancelAsWatcher(eventData)"
                    v-show="showWatcherCancelButton(eventData)"
                    v-bind:disabled="loading"
                    class="ml-2"
                >
                    視聴参加のキャンセル
                </v-btn>
                <!-- <v-btn
                    color="secondary lighten-2"
                    @click="addWaitList(seminar)"
                    v-show="showWaitingButton(seminar)"
                >
                    待ちリストに登録
                </v-btn> -->
            </div>
            <div>
                <v-btn
                    color="primary lighten-2"
                    @click="createGoogleCalendarEvent(eventData)"
                    v-show="showGCalendarButton(eventData)"
                    v-bind:disabled="loading"
                    class="ml-2"
                >
                    Googleカレンダーに登録
                </v-btn>
            </div>
        </v-card-actions>
    </div>
    
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    
    export default {
        props: {
            eventData: Object,
            isShowCloseButton: Boolean,
        },
        mounted(){
        },
        data() {
            return {
                dialogm1: '',
                dialog: false,  
                chipsAttend:[],
                itemsAttend:[],
                // chips: ['Programming', 'Playing video games', 'Watching movies', 'Sleeping'],
                // items: ['Streaming', 'Eating'],
            };
        },
        methods:{
            ...mapActions(["attendEvent", "cancelEvent", "attendEventAsWatcher", "cancelEventAsWatcher", "deleteEvent"]),
            getUserName(uid){
                if(uid){
                    const index = this.users_info.findIndex(users_info => users_info.uid === uid);
                    if(index >= 0) return this.users_info[index].name;
                }
            },
            currentUserIsHost(eventData){
                if(eventData && this.login_user){
                    return eventData.host == this.login_user.uid;
                }
            },
            
            reserve(id, seminar){
                this.attendEvent({id:id, seminar:seminar, role:this.role, uid:this.uid})
            },
            cancel(seminar){
                this.cancelEvent({seminar:seminar, uid:this.uid})
            },
            
            
            reserveAsWatcher(id, seminar){
                this.attendEventAsWatcher({id:id, seminar:seminar, role:this.role, uid:this.uid})
            },
            cancelAsWatcher(seminar){
                this.cancelEventAsWatcher({seminar:seminar, uid:this.uid})
            },

            delete_event () {
                if(confirm("削除しますか？")){
                    this.deleteEvent({id:this.eventData.id});
                    this.closeWindow()
                }
            },
            getFormatDate4GoogleCalendar(dt){
                let y = dt.getFullYear();
                let M = ("00" + (dt.getMonth()+1)).slice(-2);
                let d = ("00" + dt.getDate()).slice(-2);
                let h = ("00" + dt.getHours()).slice(-2);
                let m = ("00" + dt.getMinutes()).slice(-2);
                let s = ("00" + dt.getSeconds()).slice(-2);
                return y + M + d + 'T' + h + m + s;
            },
            createGoogleCalendarEvent(seminar){
                let start = this.getFormatDate4GoogleCalendar(seminar.start)
                let end = this.getFormatDate4GoogleCalendar(seminar.end)
                let url_gcalendar = 'https://www.google.com/calendar/render?action=TEMPLATE&text=';
                url_gcalendar += seminar.name;
                url_gcalendar += '&dates=' + start + '/' + end;
                url_gcalendar += '&trp=true&ctz=Asia/Tokyo'

                // location.href = url_gcalendar
                window.open(url_gcalendar, '_blank')
            },
            
            showAttendButton(seminar){
                //ログインユーザー
                if(this.$store.state.login.login_user){
                    //主催一覧ページではない
                    if(this.navItem != 'host'){
                        if((seminar.type =='S' && this.role.attend_s) || (seminar.type =='G' && this.role.attend_g)){
                            //参加者の中に自分が含まれない
                            if(seminar.attendee && !(seminar.attendee.includes(this.$store.state.login.login_user.uid))){
                                //視聴参加者の中に自分が含まれない
                                if(!seminar.watcher || (seminar.watcher && !(seminar.watcher.includes(this.$store.state.login.login_user.uid)))){
                                    //イベントのホストが自分ではない
                                    if(seminar.host != this.$store.state.login.login_user.uid){
                                        //定員なしまたは定員以下
                                        if(seminar.capacity == 0 || seminar.capacity > seminar.attendee.length){
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            },
            showWatcherAttendButton(seminar){
                //ログインユーザー
                if(this.$store.state.login.login_user){
                    //主催一覧ページではない
                    if(this.navItem != 'host'){
                        if((seminar.type =='S' && this.role.attend_s) || (seminar.type =='G' && this.role.attend_g)){
                            //参加者の中に自分が含まれない
                            if(seminar.attendee && !(seminar.attendee.includes(this.$store.state.login.login_user.uid))){
                                //視聴参加者の中に自分が含まれない
                                if(!seminar.watcher || (seminar.watcher && !(seminar.watcher.includes(this.$store.state.login.login_user.uid)))){
                                    //イベントのホストが自分ではない
                                    if(seminar.host != this.$store.state.login.login_user.uid){
                                        //視聴参加可能
                                        if(seminar.acceptWatcher){
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            },
            showWaitingButton(seminar){
                //ログインユーザー
                if(this.$store.state.login.login_user){
                    //主催一覧ページではない
                    if(this.navItem != 'host'){
                        //参加者の中に自分が含まれない
                        if(!(seminar.attendee && seminar.attendee.includes(this.$store.state.login.login_user.uid))){
                            //イベントのホストが自分ではない
                            if(seminar.host != this.$store.state.login.login_user.uid){
                                //定員以下
                                if(seminar.capacity <= seminar.attendee.length){
                                    return true;
                                }
                            }
                        }
                    }
                }
                return false;
            },
            showCancelButton(seminar){
                //ログインユーザー
                if(this.$store.state.login.login_user){
                    //主催一覧ページではない
                    if(this.navItem != 'host'){
                        //参加者の中に自分が含まれる
                        if((seminar.attendee && seminar.attendee.includes(this.$store.state.login.login_user.uid))){
                            //イベントのホストが自分ではない
                            if(seminar.host != this.$store.state.login.login_user.uid){
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            showWatcherCancelButton(seminar){
                //ログインユーザー
                if(this.$store.state.login.login_user){
                    //主催一覧ページではない
                    if(this.navItem != 'host'){
                        //参加者の中に自分が含まれる
                        if((seminar.watcher && seminar.watcher.includes(this.$store.state.login.login_user.uid))){
                            //イベントのホストが自分ではない
                            if(seminar.host != this.$store.state.login.login_user.uid){
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            showGCalendarButton(seminar){
                //ログインユーザー
                if(this.$store.state.login.login_user){
                    //主催一覧ページではない
                    if(this.navItem != 'host'){
                        //参加者の中に自分が含まれる
                        if((seminar.attendee && seminar.attendee.includes(this.$store.state.login.login_user.uid))){
                            //イベントのホストが自分ではない
                            if(seminar.host != this.$store.state.login.login_user.uid){
                                return true;
                            }
                        //視聴参加可能 or イベントのホストが自分
                        }else if(seminar.acceptWatcher || seminar.host == this.$store.state.login.login_user.uid){
                            return true;
                        }
                    }
                }
                return false;
            },
            splitDescription(desc){
                if(desc) return desc.split("\n")
            },
            closeWindow(){
                this.$emit('clicked-close-button')
            },
            loadChipsAttend(event){
                //現在の参加者を取得
                this.chipsAttend.splice(0, this.chipsAttend.length);
                for(var i in event.attendee){
                    this.chipsAttend.push(this.getUserName(event.attendee[i]))
                }
                
                //選択可能な参加者を取得
                //TODO.グルコンの場合は、グルコンOKな人だけにする
                //配列を初期化
                this.itemsAttend.splice(0, this.itemsAttend.length);
                for(var j in this.users_info){
                    //参加権限ある人を追加
                    if(this.users_info[j].uid !== this.uid && this.users_info[j].active && ((event.type == 'G' && this.users_info[j].role.attend_g) || event.type == 'S')){
                        this.itemsAttend.push(this.users_info[j].name)
                    }
                }
            },
            remove (item) {
                this.chipsAttend.splice(this.chipsAttend.indexOf(item), 1)
                this.chipsAttend = [...this.chipsAttend]
            },
            updateAttendee(event){
                // console.log(this.chipsAttend)
                // console.log(event.attendee)


                //コンボボックスで現在選択されているユーザーのIDを取得
                let chipsAttendIdArray = [];
                for(var i in this.chipsAttend){
                    const index = this.users_info.findIndex(user => user.name === this.chipsAttend[i]);
                    if(index >= 0){
                        //選択されたユーザーのIDを取得
                        let tmpId = this.users_info[index].uid;
                        chipsAttendIdArray.push(tmpId);
                    }
                }


                //キャンセルするユーザーをチェック(event.attendeeに含まれているが、chipsAttendに含まれていないとき)
                for(var j in event.attendee){
                    const index3 = chipsAttendIdArray.findIndex(user => user === event.attendee[j]);
                    if(index3 < 0){ 
                        //キャンセル処理
                        let newAttendee = event.attendee[j];
                        this.cancelEvent({seminar:event, uid:newAttendee})
                    }
                }


                //追加
                for(var k in this.chipsAttend){
                    const index = this.users_info.findIndex(user => user.name === this.chipsAttend[k]);
                    if(index >= 0){
                        //選択されたユーザーのIDを取得
                        let tmpId = this.users_info[index].uid;
                        // chipsAttendIdArray.push(tmpId);

                        //追加の参加者を取得（chipsAttendに含まれているが、event.attendeeに含まれていないとき）
                        const index2 = event.attendee.findIndex(user => user === tmpId);
                        if(index2 < 0){ 
                            //追加の参加処理
                            let newAttendee = this.users_info[index];
                            this.attendEvent({id:event.id, seminar:event, role:newAttendee.role, uid:newAttendee.uid})
                        }
                    }
                }

                //ダイアログを閉じる
                this.dialog = false;
            },
            clickedTag(tag){
                console.log(this.$router);
                console.log(tag)
                //検索ワードを更新
                this.$store.state.ui.searchWord = tag;

                if(this.$router.history.current.name != 'seminar.calendar'){
                    this.$router.push({name : 'seminar.calendar'});
                }
            }
        },
        computed:{
            ...mapGetters(['role', 'login_user', 'uid', 'users_info', 'loading']),
        }
    };
</script>


<style scoped lang="scss">
a{
    text-decoration :none;
}
</style>